import { z as e } from "zod";
const b = 23, y = 6, C = 255, T = 32, s = (n) => n.split(".").every((t) => Number(t) <= C), a = e.int().positive(), Se = a.brand("UserIdSchema"), he = a.brand("CampaignIdGroupSchema"), le = a.brand("AdGroupIdSchema"), ue = a.brand("CreativeGroupIdSchema"), pe = a.brand("AssetIdSchema"), Ie = a.brand("CampaignVariationIdSchema"), ge = a.brand("CreativeIdSchema"), De = a.brand("LandingIdSchema"), be = a.brand("LandingIdSchema"), ye = a.brand("TargetGroupIdSchema"), Ce = a.brand("CampaignIdSchema"), Te = a.brand("PricingModelIdSchema"), ve = a.brand("CpaAutoRuleIdSchema"), v = e.int().nonnegative().brand("DealTypeIdSchema"), A = e.int().nonnegative().brand("ContentTypeIdSchema"), Ae = a.brand("SpotIdSchema"), P = a.brand("AdTypeIdSchema"), O = a.brand("AdFormatIdSchema"), Pe = a.brand("TargetIdSchema"), Oe = a.brand("BlacklistAutoRuleIdSchema"), Be = a.brand("GoalIdSchema"), ke = a.brand("ArbitrageModelRuleIdSchema"), Ne = a.brand("PaymentTransactionIdSchema"), Re = a.brand("RotatorCampaignIdSchema"), B = e.int().min(0).max(b), k = e.int().min(0).max(y), N = e.iso.datetime({ offset: !0 }), fe = (n) => N.refine((t) => new Date(t) > /* @__PURE__ */ new Date(), { error: `${n} must be in the future!` }), je = e.string().trim().min(1), we = e.string().trim().min(1), Me = e.string().trim().min(1).brand("KeywordsSchema"), Le = e.int().min(0).max(1e4), _e = e.url().brand("MediaUrlSchema"), Ve = e.url().brand("CustomContentUrlSchema"), xe = e.string().trim().min(1), R = e.string().trim().min(1), Ge = e.number().nonnegative("bid must not be negative"), Ue = e.number().positive(), r = 0.01, Ee = e.number().min(r, { message: `Budget limit must be at least $${r}` }), Fe = e.number().nonnegative(), Xe = 1e-4, $e = 1e5, We = e.int().positive(), ze = e.int().min(0).max(100), f = e.ipv4().or(e.ipv6()), j = e.string().regex(/^(\d{1,3}\.){3}\d{1,3}\/(\d{1,2}|(\d{1,3}\.){3}\d{1,3})$/, "Invalid network mask notation").refine((n) => {
  const [t, o] = n.split("/");
  return t === void 0 || o === void 0 || !s(t) ? !1 : o.includes(".") ? s(o) : Number(o) <= T;
}, "Invalid network mask notation"), w = e.union([j, e.cidrv6()]), M = e.string().transform(
  (n) => n.split("-").map((t) => t.trim()).join("-")
).refine(
  (n) => {
    const t = n.split("-");
    return t.length !== 2 ? !1 : e.ipv4().or(e.ipv6()).safeParse(t[0]).success && e.ipv4().or(e.ipv6()).safeParse(t[1]).success;
  },
  { message: "Invalid IP range" }
), L = e.string().trim().min(1).regex(/^.+@.+\..+$/, "Email format is invalid."), _ = e.string().min(1).regex(
  /^[A-Z][A-Za-z0-9() ]+$/,
  "Ad format must start with a capital letter and restricted to letters, digits, parentheses and spaces. See table ad_unit_formats for details."
).brand("DictAdUnitFormatNameSchema"), He = L.brand("UsernameSchema"), Ke = e.string().trim().min(1).brand("PasswordSchema"), Ze = e.literal("Bearer"), Ye = e.string().trim().min(1).brand("AccessTokenSchema"), qe = e.string().trim().min(1).brand("RefreshTokenSchema"), i = e.int().nonnegative(), c = e.string().trim().min(1), S = e.string().trim().min(2).max(2), m = (n, t) => e.object({
  code: n,
  name: t
}), V = e.number().nonnegative().brand("DictLanguageIdSchema"), h = S.brand("DictIso2CodeSchema"), l = c.brand("DictLanguageNameSchema"), Je = m(
  h,
  l
).readonly(), Qe = e.object({
  id: V,
  iso2: h,
  iso3: e.string().trim().min(3).max(3),
  name: l
}), u = e.string().trim().min(2).brand("DictRegionCodeSchema"), x = c.brand("DictRegionNameSchema"), G = m(u, x).readonly(), p = S.brand("DictCountryCodeSchema"), U = c.brand("DictCountryNameSchema"), ea = e.object({
  code: p,
  regionCodes: e.array(u).readonly().nullish()
}), E = m(p, U), aa = E.extend({
  regions: e.array(G).readonly().nullish()
}).readonly(), F = i.brand("DictDeviceIdSchema"), X = c.brand("DeviceTypeSchema"), ta = e.object({
  id: F,
  name: X
}).readonly(), I = i.brand("DictOsVersionIdSchema"), $ = c.brand("DictOsVersionNameSchema"), W = e.object({
  id: I,
  name: $
}).readonly(), g = i.brand("DictOsIdSchema"), z = c.brand("DictOsNameSchema"), H = e.object({
  id: g,
  versionIds: I.array().readonly().nullish()
}), K = e.object({
  id: g,
  name: z,
  versions: e.array(W).readonly().nullish()
}).readonly(), D = i.brand("DictOsTypeIdSchema"), Z = c.brand("DictOsTypeNameSchema"), na = e.object({
  typeId: D,
  oses: H.array().readonly().nullish()
}), ca = e.object({
  typeId: D,
  typeName: Z,
  oses: e.array(K).readonly().nullish()
}).readonly(), Y = i.brand("DictBrowserIdSchema"), q = c.brand("DictBrowserTypeSchema"), ia = e.object({
  id: Y,
  name: q
}).readonly(), J = i.brand("DictBlacklistStatusIdSchema"), Q = c.brand("DictBlacklistStatusNameSchema"), oa = e.object({
  id: J,
  name: Q
}).readonly(), ee = i.brand("DictBlacklistBanTypeIdSchema"), ae = c.brand("DictBlacklistBanTypeNameSchema"), ma = e.object({
  id: ee,
  name: ae,
  // Machine-readable discriminator of the ban flavour ('default', 'ip', 'fraud', 'domain', ...)
  code: e.string().trim().min(1).nullable()
}).readonly(), te = i.brand("DictBlacklistConditionParamIdSchema"), ne = c.brand(
  "DictBlacklistConditionParamNameSchema"
), sa = e.object({
  id: te,
  name: ne
}).readonly(), d = e.string().trim().min(1).brand("DictCategoryIdSchema"), ce = e.number().nonnegative().brand("DictCategoryExtIdSchema"), ra = e.object({
  id: d,
  name: e.string().trim().min(1),
  idParent: d.nullish(),
  extId: ce.nullish()
}), da = e.union([w, M, f]), ie = e.object({
  day: k,
  hours: e.array(B).readonly()
}).readonly(), Sa = e.object({
  days: e.array(ie).min(1).readonly(),
  timezone: e.string().trim().min(3)
}).readonly(), ha = e.enum(["enabled", "disabled"]), la = e.enum([
  "Image",
  // 1
  "Video"
  // 2
]), ua = e.enum([
  "Animated",
  // 1
  "Static"
  // 2
]), oe = e.enum(["Reviewing", "Approved", "Rejected"]), pa = e.enum([...oe.options, "Incompleted"]), Ia = e.enum(["even", "fast"]), ga = e.enum(["Hidden", "Active", "Rejected", "Reviewing", "Stopped", "Paused"]), me = e.enum([
  "CampaignDealType_None",
  "CampaignDealType_SSP",
  "CampaignDealType_DIRECT",
  "CampaignDealType_ALL"
]), Da = e.enum([
  "AssetApproved",
  "AssetRejected",
  "AssetInReview",
  "NoAssets",
  "WaitingAction"
]), ba = e.enum(["CPM", "CPC", "CPV", "CPA", "DCPM", "MXDCPM"]), se = e.enum([
  "Banner",
  "Video",
  "Push",
  "Popunder",
  "Native",
  "Interstitial",
  "Audio",
  "VideoSlider",
  "Link",
  "Vast",
  "OutstreamVideo",
  "Multispot",
  "InPage"
]), ya = e.enum(["Default", "No referrer", "Origin"]), re = e.object({
  id: O,
  name: _
}).readonly(), Ca = e.object({
  id: P,
  name: se,
  formats: e.array(re).optional()
}).readonly(), Ta = e.object({
  id: v,
  priority: me,
  description: e.string().nullable()
}).readonly(), va = e.object({
  id: A,
  name: R
}).readonly();
export {
  Ye as AccessTokenSchema,
  O as AdFormatIdSchema,
  _ as AdFormatSchema,
  le as AdGroupIdSchema,
  P as AdTypeIdSchema,
  se as AdTypeSchema,
  ke as ArbitrageModelRuleIdSchema,
  pe as AssetIdSchema,
  pa as AssetStatusSchema,
  r as BUDGET_LIMIT_MIN,
  Ze as BearerTokenTypeSchema,
  Ge as BidSchema,
  Oe as BlacklistAutoRuleIdSchema,
  Ee as BudgetLimitInputSchema,
  Ue as BudgetLimitSchema,
  v as CampaignDealTypeIdSchema,
  me as CampaignDealTypeSchema,
  he as CampaignGroupIdSchema,
  Ce as CampaignIdSchema,
  Da as CampaignStatusChangeReasonSchema,
  ga as CampaignStatusSchema,
  Ie as CampaignVariationIdSchema,
  ya as ClickRedirectTypeSchema,
  A as ContentTypeIdSchema,
  R as ContentTypeNameSchema,
  ve as CpaAutoRuleIdSchema,
  ue as CreativeGroupIdSchema,
  ge as CreativeIdSchema,
  la as CreativeTypeSchema,
  Le as CreativeVariationWeightSchema,
  xe as CustomContentSchema,
  Ve as CustomContentUrlSchema,
  N as DateTimeSchema,
  k as DayOfWeekSchema,
  ie as DayScheduleSchema,
  Ia as DeliverySchema,
  X as DeviceTypeSchema,
  re as DictAdUnitFormatOutputSchema,
  Ca as DictAdUnitTypesOutputSchema,
  ee as DictBlacklistBanTypeIdSchema,
  ae as DictBlacklistBanTypeNameSchema,
  ma as DictBlacklistBanTypeSchema,
  te as DictBlacklistConditionParamIdSchema,
  ne as DictBlacklistConditionParamNameSchema,
  sa as DictBlacklistConditionParamSchema,
  J as DictBlacklistStatusIdSchema,
  Q as DictBlacklistStatusNameSchema,
  oa as DictBlacklistStatusSchema,
  Y as DictBrowserIdSchema,
  ia as DictBrowserSchema,
  q as DictBrowserTypeSchema,
  ce as DictCategoryExtIdSchema,
  d as DictCategoryIdSchema,
  ra as DictCategorySchema,
  va as DictContentTypeOutputSchema,
  p as DictCountryCodeSchema,
  U as DictCountryNameSchema,
  E as DictCountryOutputSchema,
  Ta as DictDealTypeOutputSchema,
  F as DictDeviceIdSchema,
  ta as DictDeviceSchema,
  ea as DictGeoInputSchema,
  aa as DictGeoOutputSchema,
  h as DictLanguageCodeSchema,
  V as DictLanguageIdSchema,
  l as DictLanguageNameSchema,
  Qe as DictLanguageOutputSchema,
  na as DictOSTypeInputSchema,
  ca as DictOSTypeOutputSchema,
  g as DictOsIdSchema,
  H as DictOsInputSchema,
  z as DictOsNameSchema,
  K as DictOsOutputSchema,
  D as DictOsTypeIdSchema,
  Z as DictOsTypeNameSchema,
  I as DictOsVersionIdSchema,
  $ as DictOsVersionNameSchema,
  u as DictRegionCodeSchema,
  x as DictRegionNameSchema,
  G as DictRegionOutputSchema,
  Je as DimensionLanguageOutputSchema,
  we as DomainNameSchema,
  L as EmailSchema,
  je as FilenameSchema,
  Be as GoalIdSchema,
  B as HourSchema,
  f as IPAddressSchema,
  w as IPNetworkSchema,
  M as IPRangeSchema,
  da as IPSelectorSchema,
  ua as ImageTypeSchema,
  Me as KeywordsSchema,
  be as LandingGroupIdSchema,
  De as LandingIdSchema,
  _e as MediaUrlSchema,
  a as NumericIdSchema,
  ha as OnOffSchema,
  $e as PRICE_MAX,
  Xe as PRICE_MIN,
  Ke as PasswordSchema,
  Ne as PaymentTransactionIdSchema,
  ze as PercentSchema,
  Te as PricingModelIdSchema,
  ba as PricingRuleModelSchema,
  qe as RefreshTokenSchema,
  oe as ReviewStatusSchema,
  Re as RotatorCampaignIdSchema,
  Ae as SpotIdSchema,
  Fe as StoredBudgetLimitSchema,
  ye as TargetGroupIdSchema,
  Pe as TargetIdSchema,
  We as TrafficLimitSchema,
  Se as UserIdSchema,
  He as UsernameSchema,
  Sa as WeekScheduleSchema,
  m as buildDictOutputSchema,
  fe as futureDateSchema
};
//# sourceMappingURL=schemas.js.map
